<template>
  <div>
    <b-modal :title="'اضافه کردن موضوع'" id="skillUpCategoryModal" v-model="showModal" no-close-on-esc header-close-variant="dark" hide-footer centered>
      <BaseText
        required
        :showError="titleError"
        :value="selectedCategory.title"
        @input="selectedCategory.title = $event"
        title="عنوان "
        placeholder="عنوان"
        labelClass="labelClass"
      />
      <div class="d-flex mt-3">
        <div class="d-flex align-items-center me-5">آیکون</div>
        <ImageUploader
          :img="file"
          :uploadLoading="uploadLogoLoading"
          title="عکس آیکون موضوع را انتخاب کنید"
          class="w-100 ms-3"
          @uploadImage="uploadLogo"
          @deleteImage="
            selectedCategory.logo = ''
            file = ''
          "
          isFile
        />
      </div>
      <b-form-checkbox v-model="selectedCategory.notShow" class="mt-3">
        <div class="mx-1">عدم نمایش موضوع</div>
      </b-form-checkbox>
      <div class="d-flex justify-content-end align-items-center mt-3 gap-2">
        <b-button variant="secondary" @click="$bvModal.hide('skillUpCategoryModal'), (selectedCategory = {})">انصراف</b-button>

        <!-- <b-button variant="primary ms-2 px-5" @click="addCategory">ثبت</b-button> -->
        <Button @click.native="addCategory" :loading="loading" text="ثبت" btnClass="upload-btn btn-border" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import skillUpCategoryProvider from '../../../services/skillUp/category'
import Button from '../../common/Button.vue'
import ImageUploader from '../../user/ImageUploader.vue'
import fileMannager from '../../../services/file'

export default {
  name: 'AddCategory',
  components: { BaseText, Button, ImageUploader },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
  },
  data: () => {
    return {
      selectedCategory: {
        id: undefined,
        title: '',
        logo: '',
        notShow: false,
      },
      file: '',
      loading: false,
      uploadLogoLoading: false,
      showModal: false,
      titleError: false,
    }
  },
  watch: {
    async category(val) {
      if (val) this.selectedCategory = val
      if (this.selectedCategory.logo) {
        this.file = await this.downloadSVG(this.selectedCategory.logo)
      }
    },
    showModal(val) {
      if (!val) {
        this.selectedCategory = {}
        this.titleError = false
      }
    },
  },
  methods: {
    async downloadSVG(url) {
      try {
        const response = await fetch(url)
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText)
        }
        const svgText = await response.text()
        return 'data:image/svg+xml;base64,' + btoa(svgText)
      } catch (error) {
        return url
      }
    },
    async uploadLogo(e) {
      this.uploadLogoLoading = true
      const file = e.target.files[0]
      let formData = new FormData()
      formData.append('ListFiles', file)
      const req = await fileMannager.addFile(formData)
      this.uploadLogoLoading = false
      this.selectedCategory.logo = req.data.data[0].downloadUrl
      this.file = await this.downloadSVG(this.selectedCategory.logo)
    },
    async addCategory() {
      console.log('yes')
      if (!this.selectedCategory.title) return (this.titleError = true)
      let result
      const payload = { ...this.selectedCategory }
      this.loading = true
      try {
        if (this.$route.params.slug === 'skillupcategory') {
          if (this.selectedCategory.id) result = await skillUpCategoryProvider.updateCategoryCourse(payload)
          else result = await skillUpCategoryProvider.AddCategoryCourse(payload)
        } else if (this.$route.params.slug === 'skillupcategorypackage') {
          if (this.selectedCategory.id) result = await skillUpCategoryProvider.updateCategoryPackage(payload)
          else result = await skillUpCategoryProvider.AddCategoryPackage(payload)
        }
        if (result.status >= 200 || result.status <= 204) {
          this.$emit('update')
          this.showModal = false
          this.selectedCategory = {}
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.labelClass {
  min-width: 10px !important;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
</style>
